import { Shortlist } from '../types'

export type ShortlistToProfileMap = Map<string, Shortlist[]>

export const shortlistProfileMap = (shortlists: Shortlist[]): ShortlistToProfileMap => {
  const profileIdShortlistsMap: ShortlistToProfileMap = new Map()

  shortlists.forEach(shortlist => {
    shortlist.profiles.forEach(({ searchDocId, profileType }) => {
      const key = `${profileType}_${searchDocId}`

      const shortlistsArray = profileIdShortlistsMap.get(key)

      if (shortlistsArray) {
        shortlistsArray.push(shortlist)
      } else {
        profileIdShortlistsMap.set(key, [shortlist])
      }
    })
  })

  return profileIdShortlistsMap
}
